import * as React from 'react'
import clsx from 'clsx'

import Layout from '@/components/Layout'
import { Logo, Menu, MenuList } from '.'

/**
 * @component Navbar
 * @description Fixed top navigation bar. Hides when scrolled past the hero section
 * using a passive rAF-throttled scroll listener — no forced reflow.
 */
const Navbar: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = React.useState(false)
	const [isHidden, setIsHidden] = React.useState(false)

	React.useEffect(() => {
		let raf: number
		const onScroll = () => {
			cancelAnimationFrame(raf)
			raf = requestAnimationFrame(() => {
				setIsHidden(window.scrollY > window.innerHeight)
			})
		}
		window.addEventListener('scroll', onScroll, { passive: true })
		return () => {
			window.removeEventListener('scroll', onScroll)
			cancelAnimationFrame(raf)
		}
	}, [])

	const toggleOpenMenu = () => {
		setIsMenuOpen((prev) => !prev)
	}

	React.useEffect(() => {
		document.body.style.overflow = isMenuOpen ? 'hidden' : ''
		return () => { document.body.style.overflow = '' }
	}, [isMenuOpen])

	return (
		<Layout classNameContainer={clsx(
			'fixed top-0 left-0 w-full h-16 z-50 bg-green-500 transition-transform duration-300',
			'md:h-30',
			isHidden ? '-translate-y-full' : 'translate-y-0'
		)}>
			<nav className="w-full flex items-center justify-between">
				<Logo />
				<Menu
					isMenuOpen={ isMenuOpen }
					toggleOpenMenu={ toggleOpenMenu }
				/>
				<MenuList
					isMenuOpen={ isMenuOpen }
					toggleOpenMenu={ toggleOpenMenu }
				/>
			</nav>
		</Layout>
	)
}

export default Navbar
